"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateEspSync = void 0;

var getUpdateEspSync = function getUpdateEspSync(state) {
  return state.modules.marketing['email-service-provider'].staged.updateEspSync;
};

exports.getUpdateEspSync = getUpdateEspSync;